import axios from "axios";
import { buildApiUrl } from "./apiConfig";

export const fetchTrackingKeys = async (getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.get(buildApiUrl("tracking-keys/"), { headers });
  return Array.isArray(response.data) ? response.data : [];
};

export const createTrackingKey = async ({ name, isDefaultForTours = false }, getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.post(
    buildApiUrl("tracking-keys/"),
    { name, is_default_for_tours: isDefaultForTours },
    { headers }
  );
  return response.data;
};

export const rotateTrackingKey = async (id, getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.post(buildApiUrl(`tracking-keys/${id}/rotate/`), {}, { headers });
  return response.data;
};

export const updateTrackingKey = async (id, updates, getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.patch(buildApiUrl(`tracking-keys/${id}/`), updates, { headers });
  return response.data;
};

export const deleteTrackingKey = async (id, getApiHeaders) => {
  const headers = await getApiHeaders();
  await axios.delete(buildApiUrl(`tracking-keys/${id}/`), { headers });
};

export const fetchTrackingKeySecret = async (id, getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.get(buildApiUrl(`tracking-keys/${id}/secret/`), { headers });
  return response.data;
};

export const setDefaultTourTrackingKey = async (id, getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.post(
    buildApiUrl(`tracking-keys/${id}/set-default-for-tours/`),
    {},
    { headers }
  );
  return response.data;
};

export const fetchTourTrackingLocation = async (tourId, getApiHeaders) => {
  const headers = await getApiHeaders();
  const response = await axios.get(buildApiUrl(`tour/${tourId}/tracking-last-location/`), { headers });
  return response.data;
};

export const fetchTourTrackingSegmentTracks = async (tourId, getApiHeaders, params = {}) => {
  const headers = await getApiHeaders();
  const response = await axios.get(buildApiUrl(`tour/${tourId}/tracking-segment-tracks/`), {
    headers,
    params,
  });
  return response.data;
};

export const fetchTrackingKeyPositions = async (id, getApiHeaders, params = {}) => {
  const headers = await getApiHeaders();
  const response = await axios.get(buildApiUrl(`tracking-keys/${id}/positions/`), {
    headers,
    params,
  });
  return response.data;
};
